import { Component } from '@angular/core';
import { StockMenuComponent } from '@stock-core/components/stock-menu/stock-menu.component';
import {
  ContentWithActionComponent,
} from '@stock-core/components/layouts/content-with-action/content-with-action.component';

@Component({
  selector: 'rc-home',
  standalone: true,
  imports: [StockMenuComponent, ContentWithActionComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
}
